import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useBondsAssetClassesContext } from '@/finsight/application/Bonds/BondsAssetClassesContext';

import BondType from '@/finsight/domain/BondType';
import Inventory from '@/finsight/ui/components/bonds/common/BondTables/Inventory';
import Bwic from '@/finsight/ui/components/bonds/common/BondTables/Bwic';
import { BI_MODULE } from '@/condor/ui/components/FinsightManager/constants';
import { useTrackAnalytics } from '@/finsight/application/useTrackAnalytics';

import EmptyMessageWithLink from '@/finsight/ui/common/components/EmptyMessageWithLink';
import URL from '@/finsight/Router/urlConstants';
import InventoryRow from '@/finsight/ui/components/bonds/common/BondTables/Inventory/InventoryRow';
import BwicRow from '@/finsight/ui/components/bonds/common/BondTables/Bwic/BwicRow';
import { getColumns as getBwicHeaderColumns } from '@/finsight/ui/components/bonds/common/BondTables/Bwic/BwicColumns';
import { getColumns as getInventoryHeaderColumns } from '@/finsight/ui/components/bonds/common/BondTables/Inventory/InventoryColumns';

const stateSelector = (state) => ({
  activeTab: state.finsight.bonds.metadata.activeTab,
});

const BondsTables = () => {
  const { activeTab } = useSelector(stateSelector);
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { trackAnalytics } = useTrackAnalytics();

  useEffect(() => {
    trackAnalytics({ module: BI_MODULE });
  }, []);

  if (BondType.isInventories(activeTab)) {
    return (
      <Inventory
        emptyMessage={ (
          <EmptyMessageWithLink
            text="Explore all other"
            linkTo={ `${ URL.BONDS_INVENTORIES_ABS }` }
            linkTitle="BWICS & Inventory"
          />
        ) }
        isItemsPerPageVisible={ false }
        getHeaderColumns={ getInventoryHeaderColumns }
        inventoryRow={ InventoryRow }
        currentAssetClass={ currentAssetClass }
        withSchema={ false }
      />
    );
  }

  return (
    <Bwic
      isItemsPerPageVisible={ false }
      getHeaderColumns={ getBwicHeaderColumns }
      bwicRow={ BwicRow }
      currentAssetClass={ currentAssetClass }
      withSchema={ false }
    />
  );
};

export default BondsTables;
